import { toAssetImages } from ".";

export enum IMG_WIDTH {
  W_96 = "96",
  W_256 = "256",
  W_384 = "384",
  W_640 = "640",
  W_750 = "750",
  W_1200 = "1200",
  W_1920 = "1920",
  ORIGINAL = "",
}

export const getImageBySize = (src: string, size: IMG_WIDTH): string => {
  if (!src) return "";
  const resolved = toAssetImages(src);
  if (size === IMG_WIDTH.ORIGINAL) return resolved;
  return `/_next/image?url=${encodeURIComponent(resolved)}&w=${size}&q=100`;
};

export const getImageMain = (src: string): string => {
  return getImageBySize(src, IMG_WIDTH.W_640);
};

export const getImageZoom = (src: string): string => {
  return getImageBySize(src, IMG_WIDTH.W_1920);
};
